import * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';
import './mutators/index';
import './orchestrators/loadAutomaticRepliesBannerOptionsOrchestrator';

export { default as getSelectedMailListItemsCount } from './utils/getSelectedMailListItemsCount';

/**
 * lazy load heavy dependent utils from mini-mail-list-rsvp
 */
const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(
        /* webpackChunkName: "MailListStoreUtils", webpackPrefetch: true */ './lazyIndex'
    )
);

export const lazyHandleLoadItemResponse = new LazyAction(lazyModule, m => m.handleLoadItemResponse);
